import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import RedialChart from './RedialChart';
import { api, endpoint } from '../../api';

const DialView = () => {
    const { id } = useParams()

    const [dial, setDial] = useState({})

    const getDial = async () => {
        const { result, success } = await api.get(endpoint.dial + '/' + id)
        if (success) {
            setDial(result)
        }
    }

    useEffect(() => {
        getDial()
    }, [])






    return (
        <div className="card p-3 m-3">
            <div className="d-flex align-items-center justify-content-between">
                <div>
                    <label className="az-content-label">Manage Dial</label>
                    <span className="d-block py-2">Dial View</span>
                </div>
            </div>
            <div className='row'>
                <div className="col-md-6">
                    { Object.keys(dial).length > 0 ? <RedialChart data={dial} /> : "No Data Found" } 
                </div>
                {/* <div className="col-md-6">
                    <RedialChart title='Ambient Temperature' />
                </div> */}
            </div>
        </div>
    );
};

export default DialView;